import { Col, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { SpinnerBox } from 'components/SpinnerBox';
import { Card } from 'components/enmon/card';
import type { ReactNode, VFC } from 'react';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  h1,
  h3 {
    font-weight: normal;
    white-space: nowrap;
  }

  .ant-row {
    width: 100%;
  }

  .anticon {
    font-size: 48px;
  }

  .ant-spin {
    display: block;
    /* remove annoying bump on loaded data */
    margin-bottom: 28px;
  }

  .ant-space {
    display: flex;
  }
`;

interface StatTileProps {
  value: number;
  title: string;
  icon: ReactNode;
  isLoading: boolean;
}

export const StatTile: VFC<StatTileProps> = ({ value = 0, title, icon, isLoading }) => (
  <StyledCard $sameHeight>
    <Row>
      <Col md={18} xl={16} xs={14}>
        <Space align="start" orientation="vertical" size={0}>
          {isLoading ? <SpinnerBox /> : <Title level={1}>{value}</Title>}
          <Title level={3}>{title}</Title>
        </Space>
      </Col>
      <Col md={6} xl={8} xs={10}>
        <Space align="end" orientation="vertical">
          {icon}
        </Space>
      </Col>
    </Row>
  </StyledCard>
);
